<template>
  <v-app>
    <!-- Sidebar -->
    <v-navigation-drawer
      v-if="isLogado"
      :value="sidebarOpen"
      @input="setSidebarOpen"
      app
      clipped
      color="#f5deb3"
      width="auto"
    >
      <ListaSideBar />
    </v-navigation-drawer>
    <!-- Header -->
    <v-card app flat class="app-header elevation-0">
      <div>
        <div class="text-center mt-3">
          <v-icon style="margin: auto" size="36" color="white">mdi-school</v-icon>
          <h3 class="header-h3" style="text-align: center">SECED</h3>
        </div>
      </div>
      <div class="header-bar-wrapper">
        <!-- Ícone do menu para abrir/fechar sidebar -->
        <v-btn v-if="isLogado" class="mx-2" fab dark small color="#8B4513" title="Menu" @click="toogleOpenSidebar">
          <v-icon color="white" size="28">mdi-menu</v-icon>
        </v-btn>
        <v-btn class="mx-2" fab dark small color="#8B4513" @click="irParaInitPage" title="Ir para página inicial">
          <v-icon color="white" size="28">mdi-file-document-edit-outline</v-icon>
        </v-btn>

        <v-btn
          v-if="!isLogado"
          class="mx-2"
          fab
          dark
          small
          color="#8B4513"
          title="Acesso administrativo"
          @click="abrirLogin"
        >
          <v-icon color="white" size="28">mdi-login-variant</v-icon>
        </v-btn>
        <v-btn v-if="isLogado" color="#8B4513" class="mx-2" fab dark small title="Logout" @click="logout">
          <v-icon color="white" size="28">mdi-logout</v-icon>
        </v-btn>
      </div>
    </v-card>

    <!-- Main Content -->
    <v-main>
      <div v-if="!loading" class="content-wrapper content-center">
        <router-view></router-view>
      </div>
      <v-dialog v-model="loading" persistent max-width="300">
        <v-card color="primary" dark>
          <v-card-text class="d-flex flex-column align-center justify-center pa-8">
            <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
            <span class="text-h6">Aguarde...</span>
            <small class="mt-2">Carregando dados...</small>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>

    <!-- Footer -->
    <v-footer class="app-footer elevation-0" :fixed="false" padless>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="10" md="8" lg="6">
            <v-card class="footer-card elevation-0" tile>
              <v-card-text class="text-center footer-padding">
                <div class="footer-content">
                  <div class="year-info">
                    <v-icon color="primary" class="mr-2">mdi-calendar</v-icon>
                    <span class="year-text">{{ new Date().getFullYear() }}</span>
                    <span class="separator">—</span>
                    <strong class="brand-text">G-ase</strong>
                  </div>
                  <div class="developer-info">
                    <v-icon color="grey" size="16" class="mr-1">mdi-code-tags</v-icon>
                    <small class="developer-text">PAX Code</small>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CredenciamentoServices from "./services/acesso/CredenciamentoServices";
import ListaSideBar from "@/components/App/SideBarApp.vue";
import Vue from "vue";
const EventBus = new Vue();
export default {
  name: "App",
  data: () => ({
    imagemSrc: require("@/assets/brasao.png"),
    // sidebarOpen removido, agora controlado apenas pelo Vuex
    state: Vue.observable({ token: localStorage.getItem("token") }),
    EventBus,
    loading: true,
    // ...existing code...
  }),
  components: {
    ListaSideBar,
  },
  computed: {
    ...mapGetters({ isLogado: "login/getLogado", sidebarOpen: "config/getSidebarOpen" }),
    isSidebarVisible() {
      return !!this.state.token;
    },

    payloadToken() {
      const token = this.state.token;
      if (!token) return null;
      try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) return null;
        const base64 = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        return JSON.parse(jsonPayload);
      } catch (e) {
        return null;
      }
    },
  },
  methods: {
    ...mapActions({ requestProcessos: "avaliacao/requestProcessos" }),
    ...mapMutations({ setSidebarOpen: "config/setSidebarOpen" }),

    toogleOpenSidebar() {
      this.setSidebarOpen(!this.$store.getters["config/getSidebarOpen"]);
    },
    irParaInitPage() {
      this.$router.push({ name: "initPage" });
    },
    abrirLogin() {
      this.$router.push({ name: "Login" });
    },
    async logout() {
      await CredenciamentoServices.logOff();
      CredenciamentoServices.validarLog();
    },
    // ...existing code...
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    entrarTelaCheia() {
      var doc = window.document;
      var docEl = doc.documentElement;
      var requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      var exitFullScreen =
        doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
      } else {
        exitFullScreen.call(doc);
      }
    },

    async carregarProcessos() {
      try {
        let param = {};
        //parametros da url verificar se tem parametro startTeste
        // if (this.$route.query.startTeste) param = { display: -1 };
        //  param = { display: -1 };

        const resp = await this.requestProcessos(param);

        const processos = resp.data || [];
        this.$store.commit("config/setProcessos", processos);
      } catch (e) {
        this.$store.commit("config/setProcessos", []);
        console.error("Erro ao carregar processos App:", e);
      }
    },
    // ...existing code...
  },
  mounted: async function () {
    await this.carregarProcessos();
    CredenciamentoServices.validarLog();
  /*  if (this.isMobileDevice()) {
      this.entrarTelaCheia();
    } else {
      this.entrarTelaCheia();
    }*/
    this.loading = false;
  },
};
</script>

<style scoped>
/* HEADER ABSOLUTAMENTE CENTRALIZADO E RESPONSIVO */
.header-h3 {
  color: #fff !important;
  position: relative;

  filter: none !important;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* Remove blur do header se estiver afetando o texto */
.app-header::before {
  backdrop-filter: none !important;
}
.header-bar-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 110px;
}
.header-icon {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 2;
}
.header-left {
  left: 0;
  padding-left: 12px;
}
.header-right {
  right: 0;
  padding-right: 12px;
}
.header-title-center {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 18px;
  z-index: 1;
}
.header-title {
  color: white;
  font-weight: 400;
  font-size: 1.35rem;
  margin: 0;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  word-break: break-word;
  text-align: center;
}
.logo-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}
@media (max-width: 959px) {
  .header-bar-wrapper {
    height: 90px;
  }
  .logo-wrapper {
    width: 44px;
    height: 44px;
  }
  .header-title {
    font-size: 1rem;
  }
}
@media (max-width: 599px) {
  .header-bar-wrapper {
    height: 64px;
  }
  .logo-wrapper {
    width: 36px;
    height: 36px;
  }
  .header-title {
    font-size: 0.85rem;
  }
}
/* Ajustes para header responsivo e centralização */
.header-row {
  width: 100%;
}
.header-icon-col {
  min-width: 48px;
  max-width: 60px;
}
.header-center-col {
  flex: 1 1 0%;
  min-width: 0;
}

@media (max-width: 959px) {
  .header-center-col {
    order: 2;
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
    margin: 0 auto;
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
  }
  .header-icon-col {
    order: 1;
    min-width: 44px;
    max-width: 56px;
  }
}

@media (max-width: 599px) {
  .header-center-col {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
    margin: 0 auto;
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
  }
  .header-icon-col {
    min-width: 36px;
    max-width: 44px;
  }
}
/* Global App Styles */

.v-application {
  background: linear-gradient(135deg, #f5deb3 0%, #f0e68c 100%) !important;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}

.v-main {
  max-width: 100vw;
  overflow-x: hidden;
}

.content-wrapper {
  max-width: 100vw;
  overflow-x: hidden;
}

/* Header Styles */
.app-header {
  background: linear-gradient(135deg, #8b4513 0%, #cd853f 100%) !important;
  border: none !important;
  position: relative;
  overflow: hidden;
}

.app-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.fill-header {
  min-height: 110px;
  height: 110px;
  display: flex;
  align-items: center; /* Centraliza verticalmente */
}

.v-app-bar {
  min-height: 110px !important;
  height: 110px !important;
  box-sizing: border-box;
  padding: 0 !important;
  display: flex;
  align-items: center; /* Centraliza verticalmente */
}

.logo-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 18px;
  width: 100%;
}

.logo-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.title-section {
  text-align: left;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-title {
  color: white;
  font-weight: 400;
  font-size: 1.35rem;
  margin: 0;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  word-break: break-word;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  margin: 4px 0 0 0;
  font-weight: 400;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}

/* Main Content */
.main-content {
  background: transparent !important;
  position: relative;
  padding-top: 0 !important;
  margin-top: 0 !important;
}
.content-wrapper {
  min-height: calc(100vh - 110px); /* Ajuste para altura do header */
  padding-bottom: 20px;
  margin-top: 0 !important;
}

/* Adiciona centralização horizontal no desktop */
.content-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: calc(100vh - 110px);
  width: 100%;
}
@media (max-width: 959px) {
  .content-center {
    align-items: stretch;
    min-height: unset;
  }
}

@media (max-width: 959px) {
  .fill-header,
  .v-app-bar {
    min-height: 90px !important;
    height: 90px !important;
    align-items: center !important;
  }

  .logo-section {
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .title-section {
    text-align: center;
    align-items: center;
  }

  .header-title {
    font-size: 1rem;
    text-align: center;
    line-height: 1.3;
  }

  .logo-wrapper {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-icon {
    font-size: 36px !important;
  }
}

@media (max-width: 599px) {
  .fill-header,
  .v-app-bar {
    min-height: 64px !important;
    height: 64px !important;
    align-items: center !important;
  }

  .logo-section {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .title-section {
    text-align: center;
    align-items: center;
  }

  .header-title {
    font-size: 0.85rem;
    text-align: center;
    line-height: 1.2;
  }

  .logo-wrapper {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-icon {
    font-size: 28px !important;
  }
}

/* Footer Styles */
.app-footer {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: auto;
  position: relative !important;
  bottom: 0;
  width: 100%;
}

.footer-card {
  background: transparent !important;
}

.footer-content {
  animation: fadeInUp 1s ease-out 0.5s both;
}

.footer-padding {
  padding: 16px 16px 20px 16px !important;
}

.year-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
}

.year-text {
  color: #1976d2;
  font-weight: 500;
  font-size: 1rem;
}

.separator {
  color: #546e7a;
  margin: 0 4px;
}

.brand-text {
  color: #1976d2;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}

.developer-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.developer-text {
  color: #546e7a;
  font-size: 0.85rem;
  font-weight: 400;
}

/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 599px) {
  .v-application .v-navigation-drawer {
    z-index: 6;
  }

  .v-application .v-app-bar {
    z-index: 7;
  }

  .v-application .v-footer {
    z-index: 5;
  }
}

@media (min-width: 960px) {
  .v-application .v-navigation-drawer {
    position: fixed !important;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1 !important;
  }
  .main-content {
    margin-left: 180px !important;
    max-width: calc(100vw - 180px);
  }
  .v-navigation-drawer--close + .main-content {
    margin-left: 0 !important;
  }
}

/* Smooth transitions for all interactive elements */
* {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}
</style>
